import React, { useState } from "react";

import { Menu as MenuIcon } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";

/* =============================================================================
<ResponsiveTabs />
============================================================================= */
const ResponsiveTabs = ({
  tabData,
  selectedTab,
  fullWidth = true,
  onChange,
  title,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (tabValue) => {
    onChange(tabValue);
    setAnchorEl(null);
  };
  return (
    <Box mb={2}>
      {/* Title with space-between layout */}
      <Box
        display="flex"
        justifyContent={title ? "space-between" : "flex-start"}
        alignItems="center"
      >
        {title && (
          <Typography
            fontSize={{ xs: "18px", md: "24px" }}
            fontWeight={600}
            fontFamily="Outfit"
            textTransform="uppercase"
          >
            {title}
          </Typography>
        )}
        {isMobile && (
          <IconButton onClick={handleMenuClick}>
            <MenuIcon sx={{ width: "24px", height: "24px" }} />
          </IconButton>
        )}
      </Box>

      {isMobile ? (
        <Box mt={1}>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            keepMounted
          >
            {tabData.map((t) => (
              <MenuItem key={t.value} onClick={() => handleMenuClose(t.value)}>
                {t.title}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ) : (
        <Box borderBottom="1px solid #D8D8D8" mt={1}>
          <Tabs
            value={selectedTab}
            onChange={(_, value) => onChange(value)}
            sx={{
              "& .MuiTab-root": {
                pb: 1.5,
                flex: 1,
                width: fullWidth ? "100%" : "auto",
                color: "#000000", // Default tab color
                textTransform: "none",
                fontWeight: 400,
                fontFamily: "Outfit",
                fontSize: { xs: "12px", sm: "15px", md: "16px" },
                "&.Mui-selected": {
                  fontWeight: 600,
                  color: "#000000", // Selected tab text color
                },
              },
              "& .MuiTabs-flexContainer": {
                justifyContent: fullWidth ? "space-between" : "flex-start",
              },
              "& .MuiTabs-indicator": {
                bgcolor: "#000",
              },
            }}
          >
            {tabData.map((t) => (
              <Tab key={t.value} label={t.title} value={t.value} />
            ))}
          </Tabs>
        </Box>
      )}
    </Box>
  );
};

/* Export
============================================================================= */
export default ResponsiveTabs;
